// Shared content + data for the DMWrapped website. Edit copy here in one place.

export const SITE = {
  name: "DMWrapped",
  url: "https://dmwrapped.com",
  supportEmail: "hello@dmwrapped.com",
  // Set these once your apps are live; empty string = "coming soon".
  appStoreUrl: "",
  playStoreUrl: "",
  ogImage: "https://dmwrapped.com/logo.png",
};

export const SEO_DEFAULTS = {
  description:
    "DMWrapped turns your Instagram DM export into a beautiful, shareable Wrapped-style report — see your most-texted friends, who texts first, how fast you reply, and get a savage verdict on your DM personality. 100% private: analyzed on your device, never uploaded.",
  keywords:
    "instagram dms wrapped, dm wrapped, instagram wrapped, instagram dm analytics, instagram message stats, instagram data export, instagram chat analysis, who texts first, most texted friends instagram, reply time stats, dm personality, instagram direct message insights, year in review instagram dms",
};

export const STEPS = [
  {
    n: "1",
    title: "Request your data from Instagram",
    body: "Instagram → Settings → Accounts Center → Your information and permissions → Download your information.",
  },
  {
    n: "2",
    title: "Pick Messages, JSON, All time",
    body: "Choose your account, select Messages, set format to JSON and range to All time, then tap Create files.",
  },
  {
    n: "3",
    title: "Open the app & import the .zip",
    body: "Meta emails your download in 24–72h. Save the .zip, open DMWrapped on your phone and import it — everything is analyzed on your device, never uploaded.",
  },
];

export const LEGAL_PAGES = {
  privacy: {
    title: "Privacy Policy",
    updated: "October 2026",
    description:
      "DMWrapped privacy policy — your Instagram messages are analyzed 100% on your own device and are never uploaded to or stored on our servers.",
    sections: [
      { body: "DMWrapped is built privacy-first. Your Instagram messages are analyzed entirely on your own device — in the app or in your browser. We never upload, store, or see the contents of your DMs." },
      { heading: "What we process on your device", body: "Your Instagram data export (messages, timestamps, participant names) is read locally to generate your report. This data never leaves your device and is not sent to our servers." },
      { heading: "What we store on our servers", body: "Only what's needed for your account and subscription: your email address (if you sign up with email), a Google profile email (if you use Google sign-in), an anonymous device identifier, and a unique account id. We never store your messages." },
      { heading: "Payments", body: "Subscriptions are processed by RevenueCat and the App Store, Google Play, or our web payment provider. We never see or store your card details." },
      { heading: "Your choices", body: "You can delete your account and all associated data at any time from Settings → Delete my data, which removes your account record from our servers and clears all saved reports on your device." },
      { heading: "Contact", body: "Questions about privacy? Email hello@dmwrapped.com." },
    ],
  },
  terms: {
    title: "Terms of Use",
    updated: "October 2026",
    description: "DMWrapped terms of use — personal entertainment use, Pro subscriptions, acceptable use, and disclaimers.",
    sections: [
      { body: "By using DMWrapped you agree to these terms. DMWrapped is provided for personal, entertainment purposes." },
      { heading: "Your data", body: "You are responsible for the Instagram data you choose to upload. Analysis happens on your device; you retain ownership of your data." },
      { heading: "Subscriptions", body: "DMWrapped Pro is offered as an auto-renewing subscription (weekly or yearly). Payment is charged to your App Store, Google Play, or web payment account at confirmation. Subscriptions renew automatically unless cancelled at least 24 hours before the end of the current period. Manage or cancel anytime in your store account settings." },
      { heading: "Acceptable use", body: "Don't misuse the service, attempt to disrupt it, or use it to violate anyone's rights or applicable law." },
      { heading: "Disclaimer", body: "DMWrapped is provided \u201Cas is\u201D without warranties. Insights are generated automatically and are for fun — they are not professional advice." },
      { heading: "Contact", body: "Questions about these terms? Email hello@dmwrapped.com." },
    ],
  },
  about: {
    title: "About DMWrapped",
    description:
      "About DMWrapped — the private, on-device Instagram DM Wrapped report. Top people, reply speed, DM personality, and shareable cards.",
    sections: [
      { body: "DMWrapped turns your Instagram DM history into a beautiful, shareable \u201CWrapped\u201D-style report — your top people, reply speed, who texts first, your DM personality, and more." },
      { heading: "Private by design", body: "Everything is analyzed on your own device. We built DMWrapped so you can see your stats without ever handing your messages to anyone — including us." },
      { heading: "Made for sharing", body: "Every insight is a story-ready card. Post your verdict, your glow-up, or your compatibility with your favourite people." },
      { heading: "Get in touch", body: "Ideas, feedback, or press? Email hello@dmwrapped.com — we'd love to hear from you." },
    ],
  },
  contact: {
    title: "Contact us",
    description: "Contact the DMWrapped team — support, subscription help, feedback, and press enquiries.",
    sections: [
      { body: "We'd love to hear from you — whether it's a bug, a feature idea, a subscription question, or a press enquiry." },
      { heading: "Email", body: "hello@dmwrapped.com" },
      { heading: "Support", body: "For help with your subscription or account, include the email you signed up with so we can find you faster. We never ask for your password." },
      { heading: "Response time", body: "We typically reply within 1–2 business days." },
    ],
  },
};
